import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import DashboardCommonTable from "../../components/DashboardCommonTable";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Typography,
  notification,
  Tooltip,
} from "antd";
import { ClientNameCol, ModalText, StyledOverFlowDiv, onlyTime } from "./style";
import { formatToINR } from "../../components/FormateToINR/formatToINR";
import ThemeInput from "../../components/ThemeInput";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useCheckPassward, useRevertAutoSquare } from "../../APICall/apiHooks";
import { labelObj } from "../../Helper/constant";
import { UplineTag } from "../Users/Accounts/style";

const AutoSqureTable = React.memo(() => {
  //state
  const [showModal, setShowModal] = useState({ flag: false, data: null });
  const queryClient = useQueryClient();
  const isStale = queryClient.getQueryCache().find(["autoSqure"])?.isStale();

  //redux
  const isAuthorize = useSelector(
    (state) => state.authSlice?.additionalSharing?.restoreAutoSquarUp
  );

  // life cycle
  useEffect(() => {
    if (isStale) {
      queryClient.invalidateQueries({ queryKey: ["autoSqure"] });
    }
  }, []);

  // api call
  const getAutoSqureData = async ({ pageParam = 1 }) => {
    let response = await APICall(
      "post",
      `${EndPoints.getM2MAlert}&type=squareOff&page=${pageParam}&limit=10&isLatest=true`
    );
    return response?.data?.data;
  };

  const autoSqureQuery = useInfiniteQuery({
    queryKey: ["autoSqure"],
    queryFn: getAutoSqureData,
    getNextPageParam: (lastPage) => lastPage?.nextPage,
  });

  if (autoSqureQuery?.error) {
    notification.error({ message: autoSqureQuery?.error?.message });
  }

  // console.log("autoQuery", autoSqureQuery);
  const allData = autoSqureQuery?.data?.pages?.flatMap((el) => el?.alerts);

  // function
  const handleAction = (record) => {
    setShowModal({ flag: true, data: record });
  };

  // column
  const autoSquareColumns = [
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      align: "left",
      flex: 1,
      render: (text, record) => {
        const time = onlyTime(record?.alertTime);
        return <div>{time}</div>;
      },
    },
    {
      title: "CLIENT",
      dataIndex: "client",
      key: "client",
      align: "left",
      flex: 1,
      ellipsis: true,
      render: (text, record) => {
        return (
          <>
            {/* <Tooltip
            title={`${record?.customerId?.userId} (${record?.customerId?.accountName})`}
            placement="top"
          > */}
            <div>
              <div style={{ fontWeight: "bold" }}>{record?.customerId?.userId}</div>
              <div >{record?.customerId?.accountName}</div>
            </div>
            {/* </Tooltip> */}
          </>
        );
      },
    },
    {
      title: "UPLINE",
      dataIndex: "upline",
      key: "upline",
      align: "left",
      flex: 1,
      ellipsis: true,
      render: (text, record) => {
        let id = record?.customerId?.parent?.userId;
        return (
          <>
            {/* <Tooltip
            title={`${id} (${record?.customerId?.parent?.accountName})`}
            placement="top"
          > */}
            <div>
              <div style={{ fontWeight: "bold" }}>{id}<UplineTag color="magenta" bordered={false}>
                {labelObj[record?.customerId?.parent?.accountType]}
              </UplineTag></div>
              <div >{record?.customerId?.parent?.accountName}</div>
            </div>
            {/* </Tooltip> */}
          </>
        );
      },
    },
    {
      title: "MESSAGE",
      dataIndex: "script",
      key: "script",
      align: "left",
      flex: 1,
      render: (text, record) => {
        return <div>{record?.data?.message}</div>;
      },
    },
    {
      title: "M2M",
      dataIndex: "m2m",
      key: "m2m",
      align: "center",
      flex: 1,
      render: (text, record) => {
        let amount = Number.parseInt(record?.data?.amount);
        return <span>{formatToINR(amount)}</span>;
      },
    },
    {
      title: "LEDGER + M2M",
      dataIndex: "lot",
      key: "lot",
      align: "center",
      flex: 1,
      render: (text, record) => {
        return <span>{formatToINR(record?.data?.balance)}</span>;
      },
    },
    isAuthorize
      ? {
        title: "ACTION",
        dataIndex: "action",
        key: "action",
        align: "center",
        flex: 1,
        render: (text, record) => {
          return (
            <Button type="primary" onClick={() => handleAction(record)}>
              Restore
            </Button>
          );
        },
      }
      : {
        flex: 1,
      },
  ];

  return (
    <Col xl={12} lg={24}>
      <DashboardCommonTable
        columns={autoSquareColumns}
        tableTitle="AUTO SQUARE OFF LIST"
        dataSource={allData?.[0] ? allData : []}
        tradeQuery={autoSqureQuery}
        emptyPage={autoSqureQuery?.data?.pages?.[0]?.alerts?.length === 0}
        queryKey="autoSqure"
        isLoading={autoSqureQuery?.isLoading}
        viewMore={true}
      // allowBtn={true}
      />
      {showModal?.flag && (
        <RestoreModal data={showModal?.data} setShowModal={setShowModal} />
      )}
    </Col>
  );
});

export default AutoSqureTable;

const RestoreModal = ({ data, setShowModal }) => {
  // state
  const [loading, setLoading] = useState(false);
  // custom hook for passward verification
  const { passwardData, passwardLoding, passwardMutate, flage, setFlage } =
    useCheckPassward();
  // custome hook for revert autoSquareOff
  const { revertData, revertLoading, revertMutate } = useRevertAutoSquare();

  //form
  const [form] = Form.useForm();

  // life cycle
  useEffect(() => {
    if (passwardData?.status === 200) {
      revertMutate(data?._id);
    }
  }, [passwardData]);

  useEffect(() => {
    if (revertData?.status === 200) {
      setShowModal({ flag: false });
    }
  }, [revertData]);

  useEffect(() => {
    const load = revertLoading || passwardLoding || flage;
    if (loading !== load) {
      setLoading(load);
    }
    if (flage) {
      setFlage(false);
    }
  }, [revertLoading, passwardLoding, flage]);

  // function
  const handleCancel = () => {
    setShowModal({ flag: false });
  };
  const handleFinishFailed = (value) => {
    // console.log(value, "failed");
  };
  const handleFinish = (value) => {
    passwardMutate(value?.passward);
  };

  return (
    <>
      <Modal
        open={true}
        footer={false}
        onCancel={handleCancel}
        title={<div>Restore Auto SquareOff</div>}
        width={400}
      >
        <Row>
          <ModalText>• Update M2M limit of customer</ModalText>
          <ModalText>• Disable only position squerUp</ModalText>
          <Typography.Text style={{ marginTop: "0.5rem" }}>
            To update account {`${data?.data?.userName}(${data?.clientId})`}
            <Link
              style={{ marginLeft: "0.5rem" }}
              target="_blank"
              to={`/users/edit-account/${data?.clientId}`}
            >
              Click here
            </Link>
          </Typography.Text>
        </Row>
        <Form
          form={form}
          onFinish={handleFinish}
          onFinishFailed={handleFinishFailed}
        >
          <Row align={"left"} style={{ marginTop: "1rem" }}>
            <Col span={24}>
              <ThemeInput
                name="passward"
                title="Passward"
                inputProps={{
                  placeholder: "Enter Login Password",
                }}
                marginBottom="0rem"
                formProps={{
                  name: "passward",
                  rules: [{ required: true, message: "Passward is required" }],
                }}
              />
            </Col>
          </Row>
          <Row align={"center"} gutter={[30]} style={{ marginTop: "1rem" }}>
            <Col>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
              // onClick={handleSubmit}
              >
                Submit
              </Button>
            </Col>
            <Col>
              <Button onClick={handleCancel}>Cancel</Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
